import { IPurchaseReturn, IPurchaseReturnProducts } from "@/types/purchase-return.type";
import { IProduct } from "../../types/product.types";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = import.meta.env.VITE_API_URL;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function createPurchaseReturn(data: { purchaseOrderId: string, reason: string, purchaseOrderDescription: string, products: IPurchaseReturnProducts[] }) {

  const url = `${API_URL}/purchase-return`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return makeRequestDebounced(url, options) as Promise<ApiResponseType<IProduct>>;
}

export async function getPurchaseReturns({
  status = [],
  search = "",
  page = 1,
  itemsPerPage = "10",
  orderBy = "updatedAt",
  fields = "purchaseOrderDescription, returnRequestor, createdAt, purchaseOrderId",
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: itemsPerPage,
    fields,
  });
  status && params.append("filters[status]", status.join(","));
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);

  const url = `${API_URL}/purchase-return?${params.toString()}`;
  const result = await makeRequestDebounced(url) as ApiResponseType<IPurchaseReturn[]> & { totalItems: number };

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}


export async function getPurchaseReturnsByPurcahseOrderId(purchaseReturnId: string) {

  const url = `${API_URL}/purchase-return/by-purchaseOrderId/${purchaseReturnId}`;
  const result = await makeRequestDebounced(url) as ApiResponseType<IPurchaseReturn>

  return { ok: result.ok, data: result.data };
}
